document.addEventListener("DOMContentLoaded", function() {

	window.onload = function() {	
		// PDP active variant
		setTimeout(function() {
			if (document.querySelector('input[name="Color"]:checked') !== null) {
				document.querySelector('input[name="Color"]:checked').checked = false;
				document.querySelector('.color-swatch-select-parent.selected--solid').click();
			}
		}, 500);
	}

	// Klaviyo form
	setTimeout(function() {
		document.querySelectorAll('input[id^="model_title"]').forEach((item, index) => {
			item.addEventListener('change', function() {
				if (this.checked) {
					if (document.querySelectorAll('input[id^="model_quantity"]')[index] !== undefined) {
						document.querySelectorAll('input[id^="model_quantity"]')[index].classList.add('active');
						document.querySelectorAll('label[id^="label-model_quantity"]')[index].classList.add('active');
						document.querySelectorAll('input[id^="model_quantity"]')[index].closest('div[data-testid="form-row"]').style.marginTop = '20px';
					}					
				}else{
					if (document.querySelectorAll('input[id^="model_quantity"]')[index] !== undefined) {
						document.querySelectorAll('input[id^="model_quantity"]')[index].classList.remove('active');
						document.querySelectorAll('label[id^="label-model_quantity"]')[index].classList.remove('active');
						document.querySelectorAll('input[id^="model_quantity"]')[index].closest('div[data-testid="form-row"]').style.marginTop = '0px';
					}
				}
			});
		});
		document.querySelectorAll('input[id^="model_quantity"]').forEach((item, index) => {
			if (!item.checked) {
				item.closest('div[data-testid="form-row"]').style.marginTop = '0px';
			}
		});
	}, 3000);


	let resizeId;
	window.onresize = function(event) {
		clearTimeout(resizeId);
		resizeId = setTimeout(doneResizing, 500);
	};
	function doneResizing() {
		resizeSectionsBelowProductGallery();		
	}

	function resizeSectionsBelowProductGallery() {
		if (window.innerWidth > 1590 && document.querySelector('.product-media-carousel__viewport') !== null) {
			var productCarouselWidth = document.querySelector('.product-media-carousel__viewport').offsetWidth;
			var productCarouselLeftOffset = document.querySelector('.product-media-carousel__viewport').getBoundingClientRect().left;
			if (document.querySelector('.multicolumn--pdp-icons') != null) {
				document.querySelector('.multicolumn--pdp-icons').style.maxWidth = productCarouselWidth + 'px';
				document.querySelector('.product-details').style.maxWidth = productCarouselWidth + 'px';
				document.querySelector('.multicolumn--pdp-icons').style.marginLeft = productCarouselLeftOffset + 'px';
				document.querySelector('.product-details').style.marginLeft = productCarouselLeftOffset + 'px';
			}
		}
	}
	resizeSectionsBelowProductGallery();

	// PDP main gallery slider - custom arrows
	let thumbnailPrevButton = document.querySelectorAll('.product-thumbnail-carousel__btn--aside-prev');
	let thumbnailNextButton = document.querySelectorAll('.product-thumbnail-carousel__btn--aside-next');
	let carouselPrev = document.querySelectorAll('.carousel-btn--custom-prev');
	let carouselNext = document.querySelectorAll('.carousel-btn--custom-next');
	if (thumbnailPrevButton) {
		thumbnailPrevButton.forEach((button, index) => {
			button.closest('.product-media-carousel__carousel').querySelector('.carousel-btn--custom-prev').addEventListener('click', function() {	
				button.click();	
			});
			var target = button;
			if (target) {
				var observer = new MutationObserver((mutations) => {
					if (target.getAttribute('disabled') == "") {
						carouselPrev[index].setAttribute('disabled', true);
					}else{
						carouselPrev[index].removeAttribute('disabled');
					}
				});
				observer.observe(target, {
				  	attributes: true
				});
			}
		});
	}
	if (thumbnailNextButton) {
		thumbnailNextButton.forEach((button, index) => {
			button.closest('.product-media-carousel__carousel').querySelector('.carousel-btn--custom-next').addEventListener('click', function() {	
				button.click();	
			});
			var target2 = button;
			if (target2) {
				var observer = new MutationObserver((mutations) => {
					if (target2.getAttribute('disabled') == "") {
						carouselNext[index].setAttribute('disabled', true);
					}else{
						carouselNext[index].removeAttribute('disabled');
					}
				});
				observer.observe(target2, {
				  	attributes: true
				});
			}
		});
	}

	// PDP size guide
	if (document.querySelector('.side-guide-tab-trigger') != null) {
		document.querySelector('.side-guide-tab-trigger').addEventListener('click', function() {
			document.querySelector('.block-product_drawer_with_tabs_F9E6qX > sidebar-button').click();
		});
	}

	// PDP model view	
	document.querySelectorAll('.model-view-popup-trigger').forEach((item) => {
		item.addEventListener('click', function() {
			document.querySelector('.section-model-view').classList.add('active');
		});		
	});


			
	document.querySelectorAll('.model-view-popup__close').forEach((item) => {
		item.addEventListener('click', function() {
			document.querySelector('.section-model-view').classList.remove('active');
		});		
	});
	

	document.querySelectorAll('.model-view-select').forEach((item, index) => {
		item.addEventListener('click', function() {
			var selectedModel = this.getAttribute('data-model');
			document.querySelectorAll('.product-media-carousel-mobile').forEach((carousel, index) => {
				carousel.classList.add('product-media-carousel-mobile--hidden')
			});
			document.querySelector('.product-media-carousel-mobile--' + selectedModel).classList.remove('product-media-carousel-mobile--hidden');

			document.querySelectorAll('.product-media-carousel').forEach((carousel, index) => {
				carousel.classList.add('product-media-carousel--hidden')
			});
			document.querySelector('.product-media-carousel--' + selectedModel).classList.remove('product-media-carousel--hidden');

			document.querySelectorAll('.model-view-select').forEach((item, index) => {			
				item.removeAttribute('disabled');
				item.innerHTML = item.getAttribute('data-default-text');
			});
			this.setAttribute('disabled', '');
			this.innerHTML = this.getAttribute('data-disabled-text');
			setTimeout(function() {
				// document.querySelector('.section-model-view').classList.remove('active');
			}, 1000);			
		});
	}); 





	// Iwish
	var target = document.querySelector('.iWishCount');
	var observer = new MutationObserver((mutations) => {
		if ($('.iWishCount').html() > 0) {
		  $('.iWishCount').addClass('active');
		} else {
		  $('.iWishCount').removeClass('active');
		}
	});
	observer.observe(target, {
		subtree: true,
		childList: true,
	}); 

	// checkout terms
	if (document.querySelector('#CartPage') != null) {
		function isValidNip(nip) {
          // [PL] NIP format
          nip = nip.replace(/[\ \-]/gi, '');
          if (typeof nip !== 'string' || nip.length > 10) { return false; }

          const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
          let sum = 0;
          const controlNumber = parseInt(nip.substring(9, 10));
          const weightCount = weight.length;

          for (let i = 0; i < weightCount; i++) {
            sum += (parseInt(nip.substr(i, 1)) * weight[i]);
          }

          return sum % 11 === controlNumber;
        }

		function checkoutBtnValidation() {
			document.querySelector('#checkout').addEventListener('click', function(e) {
				e.preventDefault();

				let invoiceFormValid = true
                if (document.querySelector('#faktura').checked) {
                  document.querySelectorAll('.cart__company-fields > .input--required').forEach((item, index) => {
                    item.classList.remove('input--unvalid');
                    if (document.querySelector('body').classList.contains('lang-pl')) {
                      if (item.classList.contains('input--nip') && !isValidNip(item.value)) {
                        item.classList.add('input--unvalid');
                        invoiceFormValid = false;
                      }
                    }else{
                      if (item.value == "") {
                        item.classList.add('input--unvalid');
                        invoiceFormValid = false;
                      }
                    }
                    
                  });
                }

				if (document.querySelector('#cart-terms').checked && invoiceFormValid) {
					document.querySelector('#cart-terms').parentElement.classList.remove('field--required');			
					document.querySelector('#CartPageForm').submit();
				}else{
					document.querySelector('#cart-terms').parentElement.classList.add('field--required');			
				}
			});
		}
		checkoutBtnValidation();

		var target = document.querySelector('#CartPage');
		var observer = new MutationObserver((mutations) => {
			checkoutBtnValidation();
			invoiceFieldsEvents();
		});
		observer.observe(target, {
			subtree: true,
			childList: true,
		}); 

		function invoiceFieldsEvents() {
	      document.querySelector('#paragon').checked = true;
	      document.querySelectorAll('input[name="attributes[choose_invoice]"]').forEach((input, index) => {
	        input.addEventListener('change', function() {
	          if (this.value == 'faktura' && this.checked) {
	            document.querySelector('.cart__company-fields').classList.add('active');
	          }else{
	            document.querySelector('.cart__company-fields').classList.remove('active');
	          }
	        });
	      });
	    }
	    invoiceFieldsEvents();

	}

	// Klik w niedostępny rozmiar otwiera modal Klaviyo "Powiadom o dostępności".
	// Klaviyo BIS trzyma swój przycisk .klaviyo-bis-trigger w DOM (display:none)
	// i pokazuje go dopiero, gdy przetworzy zmianę wariantu na wyprzedany —
	// dlatego czekamy na jego widoczność, a nie samo istnienie.
	var bisPollTimer = null;
	document.addEventListener('click', function (e) {
		var label = e.target.closest('variant-picker label');
		if (label == null) { return; }

		// każda zmiana wariantu anuluje oczekujące otwarcie modala
		if (bisPollTimer != null) {
			clearInterval(bisPollTimer);
			bisPollTimer = null;
		}

		if (!label.hasAttribute('no-available')) { return; }
		var optionWrap = label.closest('[option-picker-name]');
		if (optionWrap == null || !/rozmiar|size|velikost/i.test(optionWrap.getAttribute('option-picker-name'))) { return; }

		var tries = 0;
		bisPollTimer = setInterval(function () {
			var trigger = Array.prototype.find.call(
				document.querySelectorAll('.klaviyo-bis-trigger'),
				function (t) { return t.offsetParent !== null; }
			);
			if (trigger) {
				clearInterval(bisPollTimer);
				bisPollTimer = null;
				trigger.click();
			} else if (++tries > 40) {
				clearInterval(bisPollTimer);
				bisPollTimer = null;
			}
		}, 100);
	});

});


// Announcement bar countdown timer (<countdown-timer> web component)
if (!customElements.get('countdown-timer')) {
	customElements.define('countdown-timer', class extends HTMLElement {
		connectedCallback() {
			this.endTime = new Date(this.getAttribute('data-end')).getTime();
			this.daysGroup = this.querySelector('[data-days-group]');
			this.daysEl = this.querySelector('[data-days]');
			this.hoursEl = this.querySelector('[data-hours]');
			this.minutesEl = this.querySelector('[data-minutes]');
			this.secondsEl = this.querySelector('[data-seconds]');
			this.hideZeroDays = this.getAttribute('data-hide-zero-days') === 'true';

			if (isNaN(this.endTime)) return;

			this.tick();
			this.interval = setInterval(() => this.tick(), 1000);
		}

		disconnectedCallback() {
			clearInterval(this.interval);
		}

		tick() {
			let diff = this.endTime - Date.now();

			if (diff <= 0) {
				clearInterval(this.interval);
				this.onExpired();
				return;
			}

			const days = Math.floor(diff / 86400000); diff -= days * 86400000;
			const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
			const minutes = Math.floor(diff / 60000); diff -= minutes * 60000;
			const seconds = Math.floor(diff / 1000);

			if (this.hideZeroDays && days === 0 && this.daysGroup) {
				this.daysGroup.style.display = 'none';
			}

			this.setNum(this.daysEl, days);
			this.setNum(this.hoursEl, hours);
			this.setNum(this.minutesEl, minutes);
			this.setNum(this.secondsEl, seconds);
		}

		setNum(el, value) {
			if (el) el.textContent = String(value).padStart(2, '0');
		}

		onExpired() {
			if (this.getAttribute('data-expired') === 'hide') {
				const slide = this.closest('.announcement-bar__slide');
				(slide || this).style.display = 'none';
				return;
			}
			const text = this.getAttribute('data-expired-text') || '';
			const span = document.createElement('span');
			span.className = 'announcement-countdown__expired';
			span.textContent = text;
			this.replaceChildren(span);
		}
	});
}

/* ============================================================
   Fix: dostępność opcji w variant-picker liczona po POZYCJI opcji,
   nie po samej wartości (bundle.js moduł 453 używa options.includes(value),
   co na produktach-zestawach — gdzie dwie opcje mają te same wartości
   XS/S/M/L — oznaczało każdy rozmiar jako dostępny).
   Dla zwykłych produktów wynik identyczny ze starym (zweryfikowane
   symulacją na całym katalogu, 2026-08-21). Nadpisujemy prototyp,
   bo bundle.js to kompilowany plik motywu Aurora.
   ============================================================ */
customElements.whenDefined('variant-picker').then(function () {
	var proto = customElements.get('variant-picker').prototype;
	if (!proto || !proto.setOptionsAvailable) { return; }

	proto.getVariantsByOption = function (prevOptions) {
		var availableVariants = this.variants
			.filter(function (v) { return v.available; })
			.map(function (v) { return v.options; });
		if (!prevOptions) { return availableVariants; }
		return availableVariants.filter(function (options) {
			return prevOptions.every(function (prevOption, index) {
				/* brak zaznaczenia w grupie = brak ograniczenia (utrzymuje
				   zgodność pozycji indeksów z pozycjami opcji) */
				return prevOption === null || options[index] === prevOption.value;
			});
		});
	};

	proto.setOptions = async function (options, possibleVariants, optionIndex) {
		for (const option of options) {
			const available = possibleVariants.some(function (variant) {
				return variant[optionIndex] === option.value;
			});
			const labelSelector = 'label[for="' + option.id + '"]';
			const label =
				this.querySelector(labelSelector) ||
				(await this.getDropdownElementBySelector(labelSelector));
			if (label) { label.toggleAttribute('no-available', !available); }
		}
	};

	proto.setOptionsAvailable = function () {
		var self = this;
		var groups = Array.prototype.slice.call(
			this.querySelectorAll('[data-variant-picker-option-inputs]')
		);
		var chosen = [];
		groups.forEach(function (group, index) {
			var inputs = Array.prototype.slice.call(group.querySelectorAll('input'));
			self.setOptions(inputs, self.getVariantsByOption(chosen.slice()), index);
			chosen.push(self.getCheckedInput(inputs) || null);
		});
	};

	/* przelicz selektory, które zdążyły się zamontować przed nadpisaniem */
	document.querySelectorAll('variant-picker').forEach(function (el) {
		if (el.variants) {
			try { el.setOptionsAvailable(); } catch (e) { /* noop */ }
		}
	});
});
